import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { Colors } from '../../../colors';

export const AdminNewReservationPageStyled = {
  Container: styled(Grid)<any>`
    background: ${Colors.PrimaryBackground};
    padding: 34px;
    width: 100%;
  `,
  ContainerForm: styled.div<any>`
    margin-top: 28px;
    margin-bottom: 28px;
    width: 100%;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    background-color: ${Colors.White};
  `,
  ContainerTitle: styled.div<any>`
    border-bottom: 2px solid ${Colors.UnderlinedGrey};
    background-color: ${Colors.LightGrey};
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    padding: 30px;
  `,
  TitlePage: styled.p<any>`
   font-family: EncodeSans-Regular;
    font-size: 17px;
  `,
};
